import { render, staticRenderFns } from "./SpcBrasilPF.vue?vue&type=template&id=0ab16c17"
import script from "./SpcBrasilPF.vue?vue&type=script&lang=js"
export * from "./SpcBrasilPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports